import { useTranslation } from 'react-i18next';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import InfoWithTooltip from 'components/InfoWithTooltip/InfoWithTooltip';
import EXTERNAL_URLS from 'constants/externalUrls';
import makeStyles from '@material-ui/styles/makeStyles';

const useStyles = makeStyles({
  title: { display: 'flex', gap: '4px', marginLeft: '15px' },
});

const MontonioModule = ({ handleModuleUpdate, module }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  if (!module) {
    return (
      <div>
        {t('brands.newBrandForm.moduleNotLoaded', {
          moduleName: 'Montonio',
        })}
      </div>
    );
  }

  return (
    <>
      <GridContainer>
        <GridItem xs={12}>
          <h3 className={classes.title}>
            {t('paymentType.title.montonio')}
            <InfoWithTooltip
              link={EXTERNAL_URLS.configurationMontonio}
              linkText={t('paymentType.configurationMontonio.tooltip')}
            />
          </h3>
        </GridItem>
      </GridContainer>
      <GridItem xs={6}>
        <FormTextInput
          label={t('paymentType.montonioModule.apiKey')}
          value={module.accessKey}
          onChange={e =>
            handleModuleUpdate({ ...module, accessKey: e.target.value })
          }
          inputSize={12}
        />
      </GridItem>
      <GridItem xs={6}>
        <FormTextInput
          label={t('paymentType.montonioModule.secretKey')}
          value={module.secretKey}
          onChange={e =>
            handleModuleUpdate({ ...module, secretKey: e.target.value })
          }
          inputSize={12}
        />
      </GridItem>
    </>
  );
};

export default MontonioModule;
